export const moneyFormat = (number:number)=> new Intl.NumberFormat('ru', { style: 'currency', currency: 'RUB' }).format(
    number,
  );

export function truncate(str: string, maxlength: number) {
  return str.length > maxlength ? str.slice(0, maxlength - 1) + '…' : str;
}